var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DatePipe } from '@angular/common';
import { OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { SelfService } from '../../self-services.service.ts';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
var PushNotificationLogsComponent = /** @class */ (function () {
    function PushNotificationLogsComponent(spinner, router, datePipe, bpgSelfService, dialog) {
        this.spinner = spinner;
        this.router = router;
        this.datePipe = datePipe;
        this.bpgSelfService = bpgSelfService;
        this.dialog = dialog;
        this.pushNotificationLogsDataList = [];
        this.limit = ConstantValues.pageLimit;
        this.currentPage = 1;
        this.numberOfElements = 0;
        this.tableShow = false;
        this.noDataFound = false;
        this.timeOutError = false;
        this.logsLoading = false;
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.selectedNotification = null;
        this.requestId = 0;
    }
    PushNotificationLogsComponent.prototype.ngOnInit = function () {
        try {
            this.loginData = JSON.parse(localStorage.getItem('loginData'));
        }
        catch (_error) {
            this.loginData = null;
        }
        if (!this.loginData || this.loginData.userId == null || localStorage.getItem('logOutFlag') === 'true') {
            this.router.navigate(['/log-out']);
            return;
        }
        this.userId = this.loginData.userId;
        this.getpushNotificationLogsDataList();
    };
    PushNotificationLogsComponent.prototype.ngOnDestroy = function () {
        this.requestId++;
        if (this.logsRequest) {
            this.logsRequest.unsubscribe();
        }
        if (this.logsLoading) {
            this.spinner.hide();
        }
        this.closeNotificationDialog();
    };
    PushNotificationLogsComponent.prototype.pageChanged = function (event) {
        if (!Number.isInteger(event) || event < 1 || event === this.currentPage) {
            return;
        }
        this.currentPage = event;
        this.getpushNotificationLogsDataList();
    };
    PushNotificationLogsComponent.prototype.refreshLogs = function () {
        this.currentPage = 1;
        this.getpushNotificationLogsDataList();
    };
    Object.defineProperty(PushNotificationLogsComponent.prototype, "firstShowingElement", {
        get: function () {
            return this.pushNotificationLogsDataList.length ? ((this.currentPage - 1) * this.limit) + 1 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PushNotificationLogsComponent.prototype, "lastShowingElement", {
        get: function () {
            return this.pushNotificationLogsDataList.length
                ? Math.min(this.firstShowingElement + this.pushNotificationLogsDataList.length - 1, this.numberOfElements) : 0;
        },
        enumerable: true,
        configurable: true
    });
    PushNotificationLogsComponent.prototype.getpushNotificationLogsDataList = function () {
        var _this = this;
        if (this.userId == null) {
            return;
        }
        var requestId = ++this.requestId;
        if (this.logsRequest) {
            this.logsRequest.unsubscribe();
        }
        // Assign before subscribing: a synchronous response may request the last valid page.
        var request = new Subscription();
        this.logsRequest = request;
        this.landingData = {
            "filter": { userId: this.userId },
            "moduleId": 0,
            "page": this.currentPage - 1,
            "presentRole": "",
            "searchTerm": "",
            "sortDirection": "DESC",
            "sortProperty": "log_id",
            "size": this.limit,
            "uid": ""
        };
        this.timeOutError = false;
        this.logsLoading = true;
        this.tableShow = false;
        this.noDataFound = false;
        this.pushNotificationLogsDataList = [];
        this.numberOfElements = 0;
        this.spinner.show();
        request.add(this.bpgSelfService.getpushNotificationLogsData(this.landingData).pipe(map(function (data) {
            if (!data || !Array.isArray(data.content) || data.totalElements == null ||
                !Number.isInteger(Number(data.totalElements)) || Number(data.totalElements) < data.content.length) {
                throw new Error('Invalid notification history response');
            }
            return { content: data.content.map(function (row) { return _this.normalizeNotification(row); }), totalElements: Number(data.totalElements) };
        })).subscribe(function (data) {
            if (requestId !== _this.requestId) {
                return;
            }
            _this.numberOfElements = data.totalElements;
            var lastPage = Math.max(1, Math.ceil(_this.numberOfElements / _this.limit));
            if (_this.currentPage > lastPage) {
                _this.currentPage = lastPage;
                _this.getpushNotificationLogsDataList();
                return;
            }
            _this.pushNotificationLogsDataList = data.content;
            _this.tableShow = data.content.length > 0;
            _this.noDataFound = _this.numberOfElements === 0;
            if (!_this.tableShow && !_this.noDataFound) {
                _this.timeOutError = true;
                _this.timeoutErrorMessage = 'This page of notifications could not be loaded. Retry or refresh the history.';
            }
            _this.logsLoading = false;
            _this.spinner.hide();
        }, function (err) {
            if (requestId !== _this.requestId) {
                return;
            }
            _this.logsLoading = false;
            _this.timeOutError = true;
            _this.timeoutErrorMessage = err && (err.status === 0 || err.statusText === ConstantValues.unknownError)
                ? 'Unable to reach notification history. Check your connection and retry.'
                : 'Unable to load notification history. Please retry.';
            _this.spinner.hide();
        }));
    };
    PushNotificationLogsComponent.prototype.parseList = function (value) {
        var items = Array.isArray(value) ? value : (typeof value === 'string' ? value.split(',') : []);
        return items.filter(function (item) { return typeof item === 'string'; }).map(function (item) { return item.trim(); })
            .filter(function (item) { return item && item.toLowerCase() !== 'null'; });
    };
    PushNotificationLogsComponent.prototype.normalizeNotification = function (row) {
        row = row || {};
        var sentAt = 'Date unavailable';
        var sentTimeAvailable = false;
        if (row.date != null && row.date !== '') {
            try {
                sentTimeAvailable = this.hasTimeComponent(row.date);
                sentAt = this.datePipe.transform(row.date, sentTimeAvailable ? 'MM-dd-yyyy h:mm a z' : 'MM-dd-yyyy') || 'Date unavailable';
            }
            catch (_error) {
                sentTimeAvailable = false;
            }
        }
        return __assign({}, row, { sentAt: sentAt, sentTimeAvailable: sentTimeAvailable, attachmentList: this.parseList(row.attachmentName), emailsArr: this.parseList(row.emailTo) });
    };
    PushNotificationLogsComponent.prototype.hasTimeComponent = function (value) {
        if (value instanceof Date || typeof value === 'number') {
            return true;
        }
        return /[T\s]\d{1,2}:\d{2}/.test(String(value || ''));
    };
    /** Opens the notification detail viewer for a single row
    * @class PushNotificationLogsComponent
    * @method viewNotification
    */
    PushNotificationLogsComponent.prototype.viewNotification = function (data) {
        var _this = this;
        if (this.detailsDialogRef) {
            return;
        }
        this.selectedNotification = data;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.width = '960px';
        dialogConfig.maxWidth = 'calc(100vw - 32px)';
        dialogConfig.maxHeight = 'calc(100vh - 32px)';
        dialogConfig.autoFocus = true;
        dialogConfig.ariaLabelledBy = 'notification-preview-title';
        dialogConfig.panelClass = ['pn-dialog-panel', 'pn-log-dialog-panel'];
        dialogConfig.backdropClass = 'pn-dialog-backdrop';
        this.detailsDialogRef = this.dialog.open(this.notificationDetailsDialog, dialogConfig);
        this.detailsDialogRef.afterClosed().subscribe(function () {
            _this.selectedNotification = null;
            _this.detailsDialogRef = null;
        });
    };
    PushNotificationLogsComponent.prototype.closeNotificationDialog = function () {
        if (this.detailsDialogRef) {
            this.detailsDialogRef.close();
        }
        this.selectedNotification = null;
    };
    return PushNotificationLogsComponent;
}());
export { PushNotificationLogsComponent };
